module.exports = __webpack_public_path__ + "static/media/icn-canvasers-social-selected.19f4b2eb.svg";